import request from '@/utils/request'

/**
 * 查询开户行列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryAccountBank(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/accountBank/queryAccountBank',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 添加开户行
 * @param {Object} data 开户行数据
 * @returns {Promise} Promise对象
 */
export function saveAccountBank(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/accountBank/saveAccountBank',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 修改开户行
 * @param {Object} data 开户行数据
 * @returns {Promise} Promise对象
 */
export function updateAccountBank(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/accountBank/updateAccountBank',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除开户行
 * @param {Object} data 开户行数据
 * @returns {Promise} Promise对象
 */
export function deleteAccountBank(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/accountBank/deleteAccountBank',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}